<video #target controls class="video-js vjs-default-skin" preload="auto"></video>
